// core/services/profileQrService.ts — 1.24.00 E3, the real profile QR code.
//
// ONE thin read. The server renders the QR with `segno` (the same package and
// the same options the 2FA QR already uses) and hands back an SVG STRING —
// exactly the shape `/auth/2fa/setup/` returns as `qrSvg`. The web client then
// renders it as an <img src="data:image/svg+xml;utf8,…">, never with
// dangerouslySetInnerHTML.
//
// It is a SEPARATE read on purpose: the payload must not ride on every profile
// fetch for a dialog most people never open. Called only when the share dialog
// mounts (ShareProfileDialog is mount-on-open).
//
// PERMISSION: a profile QR encodes nothing but the public /profile/<handle> URL
// anybody can already read off the address bar, so this read needs no more
// privacy than the profile page itself.
//
// Components must NOT import this directly — use hooks/useProfileQr.ts.

import { api } from '@/core/lib/apiClient';

/** `GET /users/<handle>/qr/` → `{"qrSvg": "<svg …>"}`. */
export interface ProfileQrPayload {
  qrSvg: string;
}

export const profileQrService = {
  /** The QR SVG for a member's public profile link. Leading `@` stripped, encoded. */
  async forHandle(handle: string): Promise<ProfileQrPayload> {
    return api<ProfileQrPayload>(`/users/${encodeURIComponent(handle.replace(/^@/, ''))}/qr/`);
  },
} as const;
